import React from "react";
import "../../../css/MonthTransPay.css";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Legend,
  Tooltip,
  YAxis,
  ResponsiveContainer,
} from "recharts";

interface MonthTransPayProps {
  MonthTransPay: { month: string; total: number; ride: number; paid: number }[];
}

const MonthTransPay = ({ MonthTransPay }: MonthTransPayProps) => {
  return (
    <div className="month_pay_trans_container">
      <h2 className="month_pay_trans_title">月ごとの登録者推移</h2>
      <ResponsiveContainer
        height="75%"
        width="90%"
        minHeight={240}
        minWidth={300}>
        <LineChart data={MonthTransPay} className="line_chart">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis dataKey="total" />
          <YAxis dataKey="ride" /> <YAxis dataKey="paid" />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#f4a460"
            name="ライド金額"
          />
          <Line
            type="monotone"
            dataKey="ride"
            stroke="#82ca9d"
            name="乗車金額"
          />
          <Line
            type="monotone"
            dataKey="paid"
            stroke="#8884d8"
            name="支払金額"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthTransPay;
